import React, { useEffect, useState } from 'react';
import { STATS, PRESS_QUOTES } from '../mock';
import { api } from '../api';
import { Star } from 'lucide-react';

const Stats = () => {
  return (
    <section className="py-20 bg-slate-50/60 border-y border-slate-100">
      <div className="max-w-6xl mx-auto px-5 lg:px-8">
        <h3 className="text-center text-2xl md:text-3xl font-extrabold text-[#0a1930] max-w-3xl mx-auto">
          Trusted and used for organic growth by leading brands, businesses and influencers
        </h3>

        <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-6">
          {STATS.map((s) => (
            <div key={s.label} className="text-center">
              <div className="text-4xl md:text-5xl font-extrabold plixy-gradient-text">
                {s.value}
              </div>

              <div className="mt-2 text-sm font-semibold text-slate-500">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export const PressBarInline = () => {
  const [brandName, setBrandName] = useState('IGGrowth');

  useEffect(() => {
    const loadSettings = async () => {
      try {
        const settings = await api.getPublicSettings();

        setBrandName(
          settings?.brand_name ||
          settings?.brandName ||
          'IGGrowth'
        );
      } catch (error) {
        // Keep the safe fallback if public settings are unavailable.
      }
    };

    loadSettings();
  }, []);

  const replaceBrand = (text) => {
    if (typeof text !== 'string') return text;

    return text.replace(/\{\{brand\}\}/g, brandName);
  };

  return (
    <section className="py-14 border-b border-slate-100">
      <div className="max-w-6xl mx-auto px-5 lg:px-8 grid md:grid-cols-4 gap-6">
        {PRESS_QUOTES.map((p) => (
          <div
            key={p.source}
            className="p-5 rounded-2xl bg-white border border-slate-200"
          >
            <div className="flex items-center gap-1 mb-2">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  className="w-4 h-4 fill-amber-400 text-amber-400"
                />
              ))}
            </div>

            <p className="text-sm text-slate-700 italic leading-relaxed">
              “{replaceBrand(p.quote)}”
            </p>

            <p className="mt-3 text-xs font-bold text-slate-500 uppercase tracking-widest">
              — {p.source}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Stats;
